export enum SIGNPOSTING_STEP {
  CONNECT_A_DATASOURCE = "CONNECT_A_DATASOURCE",
  CREATE_A_QUERY = "CREATE_A_QUERY",
  ADD_WIDGETS = "ADD_WIDGETS",
  CONNECT_DATA_TO_WIDGET = "CONNECT_DATA_TO_WIDGET",
  DEPLOY_APPLICATIONS = "DEPLOY_APPLICATIONS",
}
